import {
    AddSlaPolicySuccessEvent,
    DeleteSlaPolicySuccessEvent,
    GetAllSlaPolicySuccessEvent,
    SlaPolicyStateEvent,
    UpdateSlaPolicyPageEvent,
    UpdateSlaPolicySuccessEvent,
    UpdateTotalContentSlaPolicyEvent
} from './state-event'
import {SlaPoliciesPagination, SlaPolicy} from './model'

export const slaPolicyStateReducer = (state: SlaPolicy[] = [], event: SlaPolicyStateEvent<any> = { type: undefined, payload: undefined}) => {
    if (event.type === GetAllSlaPolicySuccessEvent.type) {
        return event.payload || []
    } else if (event.type === AddSlaPolicySuccessEvent.type) {
        return [...state, event.payload]
    } else if (event.type === DeleteSlaPolicySuccessEvent.type) {
        return state.filter((it) => it.id !== event.payload)
    } else if (event.type === UpdateSlaPolicySuccessEvent.type) {
        return state.map((it) => (it.originId === event.payload.originId) ? event.payload : it)
    } else {
        return state
    }
}

export const slaPoliciesPaginationStateReducer = (state: SlaPoliciesPagination = {}, event: SlaPolicyStateEvent<any> = { type: undefined, payload: undefined}) => {
    if (event.type === UpdateTotalContentSlaPolicyEvent.type) {
        state.total = event.payload
    } else if (event.type === UpdateSlaPolicyPageEvent.type) {
        state.page = event.payload
    } else {
        return state
    }
    return state
}
